/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
export { default as Avatar } from './avatar';

// Styled elements
export { Avatar as StyledAvatar, Initials as StyledInitials, Root as StyledRoot } from './styled-components';

// Flow
export * from './types';